const tracksES = {
    "view": {
        "table": {
            "title": "Editar Pistas",
            "column": {
                "name": "Nombre",
                "mixName": "Nombre del Mix",
                "mixLength": "Duración del Mix",
                "player": "Reproductor",
                "status": "Estado",
                "accStatus": "Estado Acc",
                "qc": "QC",
                "action": "Acción"
            },
            "button": {
                "edit": "Editar",
                "goToReleases": "Ir a Lanzamientos",
                "distribute": "Distribuir",
                "submitEditing": "Enviar Edición",
                "statusReady": "Listo",
                "statusNotReady": "No Listo"
            },
            "message": {
                "identityNotCheckedTooltip": "Aún no has proporcionado tu información completa, por lo tanto, no puedes distribuir los lanzamientos. Para hacerlo, por favor envía tu información.",
                "tracksNotReadyTooltip": "Por favor envía los metadatos de todas las pistas para poder distribuir el lanzamiento.",
                "tracksNotReadyForEditingTooltip": "Por favor envía los metadatos de todas las pistas para poder enviar las ediciones.",
                "distributionDisabledPreScanInProgressTooltip": "Por favor espera a que el pre-escaneo se complete primero para poder distribuir el lanzamiento.",
                "distributionDisabledPreScanNotDoneTooltip": "Por favor realiza el pre-escaneo primero para poder distribuir el lanzamiento.",
                "distributionDisabledPreScanDeclarationNotSubmittedTooltip": "Por favor envía la declaración del pre-escaneo primero para poder distribuir el lanzamiento.",
                "browserNotSupported": "Tu navegador no soporta el elemento de audio.",
                "trackUpdated": "¡La pista ha sido actualizada!"
            },
            "modal": {
                "distribute": {
                    "header": "¿Estás seguro de que toda la información ingresada es válida y representa completamente este lanzamiento?",
                    "body": {
                        "point1": "Después de esta acción, tu lanzamiento será revisado y si la información es correcta, se distribuirá en las fechas oficiales y exclusivas de distribución.",
                        "point2": "Al confirmar y aceptar este formulario, estás aceptando y cumpliendo completamente con los <1>Términos de Distribución</1>, <3>Términos de Uso</3> y <5>Política de Privacidad</5>.",
                        "point3": "Al confirmar y aceptar este formulario, estás confirmando indiscutiblemente que el contenido del lanzamiento enviado con los activos correspondientes, archivos de audio y metadatos, te pertenece exclusivamente o está completamente licenciado a tu sello.",
                        "point4": "Por la presente, aceptas completamente que serás el único responsable de cualquier información engañosa, uso no autorizado, actividad ilegal o cualquier tipo de disputa.",
                        "flaggedTracksTerms": {
                            "header": "Términos de Pistas Marcadas",
                            "point1": "Por favor ten en cuenta: <strong>'{{releaseName}}'</strong> contiene una o más pistas marcadas, se aplica una tarifa de <strong>15 €</strong> por pista marcada para entregar el lanzamiento a <strong>Spotify</strong>. Como has optado por no pagar esta tarifa en este momento, el lanzamiento no se entregará a Spotify. Al confirmar y aceptar este formulario, reconoces y aceptas estos términos.",
                            "point2": "En el futuro, si optas por que el lanzamiento se entregue a <strong>Spotify</strong>, puedes ir a la sección Marcada en la tabla de Lanzamientos y seguir las indicaciones de pago."
                        },
                        "artificialStreamingDeclaration": {
                            "header": "Declaración de Streaming Artificial",
                            "point1": "<strong>1.</strong> Entiendo completamente y acepto no participar en ninguna forma de streaming artificial, incluyendo el uso de bots, granjas de streaming, o cualquier método que manipule las métricas de DSP.",
                            "point2": "<strong>2.</strong> No pagaré ni ofreceré pago por ubicaciones en listas de reproducción, ni trabajaré con terceros que prometan ubicaciones garantizadas — entiendo que esto se considera fraude y una estafa.",
                            "point3": "<strong>3.</strong> Reconozco que tales acciones pueden resultar en la terminación inmediata, pérdida de regalías, reclamaciones legales, penalizaciones contractuales y tarifas, y reportes a DSPs y autoridades.",
                            "point4": "<strong>4.</strong> También garantizo informar y educar a cualquier artista o cliente con el que trabaje sobre estas reglas y asegurarme de que cumplan.",
                            "point5": "<strong>5.</strong> Entiendo que si participo en streaming artificial, mis datos KYC, incluyendo mi nombre completo, dirección, tarjeta de identificación y otra información personal, pueden ser compartidos con los departamentos legales de los DSP, como los de Spotify, Apple Music y otros.",
                            "point6": "<strong>6.</strong> Acepto la responsabilidad legal completa por cualquier violación.",
                            "acknowledgment": "Por la presente reconozco y acepto cumplir con los términos de Streaming Artificial mencionados anteriormente, y acepto la responsabilidad legal completa por cualquier violación."
                        }
                    },
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar y Aceptar"
                    }
                },
                "finishEditing": {
                    "header": "¿Estás seguro de que toda la información ingresada es válida y representa completamente este lanzamiento?",
                    "body": {
                        "point1": "Después de esta acción, tu lanzamiento será revisado y si la información es correcta, se redistribuirá a los socios DSP. <strong>NOTA, solo los METADATOS se enviarán a los DSP, el contenido como IMÁGENES y archivos de AUDIO no se puede actualizar de esta manera.</strong>",
                        "point2": "Al confirmar y aceptar este formulario, estás aceptando y cumpliendo completamente con los <1>Términos de Uso</1> y los Términos de nuestro Acuerdo de Distribución Exclusiva.",
                        "point3": "Al confirmar y aceptar este formulario, estás aceptando y cumpliendo completamente con la <1>Política de Privacidad</1>.",
                        "point4": "Al confirmar y aceptar este formulario, estás confirmando indiscutiblemente que el contenido del lanzamiento enviado con los activos correspondientes, archivos de audio y metadatos, te pertenece exclusivamente o está completamente licenciado a tu sello.",
                        "point5": "Por la presente, aceptas completamente que serás el único responsable de cualquier información engañosa, uso no autorizado, actividad ilegal o cualquier tipo de disputa."
                    },
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar y Aceptar"
                    }
                }
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "title": "Editar pista {{trackName}}",
                "mandatoryMetadata": "Metadatos Obligatorios",
                "required": "Requerido",
                "trackName": "Nombre de la Pista",
                "mixName": "Nombre del Mix",
                "originalmix": "Mix Original",
                "remix": "Esto es un Remix o Mix",
                "vocals": "Voces",
                "genre": "Género",
                "subGenre": "Subgénero",
                "additionalMetadata": "Metadatos Adicionales",
                "copyright": "Derechos de Autor ©",
                "copyrightYear": "Año de Derechos de Autor",
                "albumOnly": "Solo Álbum",
                "explicitContent": "Contenido Explícito",
                "isrc": "ISRC",
                "daIsrc": "ISRC Dolby Atmos",
                "generateIsrc": "Generar ISRC",
                "trackLanguageMetadata": "Metadatos de Idioma de la Pista",
                "language": "Idioma",
                "autoDetectLanguage": "Detección Automática (Idioma)",
                "accountingData": "Datos Contables",
                "labelShare": "Participación del Sello (%)"
            },
            "placeholder": {
                "select": "Seleccionar...",
                "labelShare": "ej. 50"
            },
            "help_text": {
                "trackName": "Título de la pista",
                "mixName": "Inserta el nombre del mix sin paréntesis. Algunas pistas se lanzan en más de una versión. Este campo describe la versión, por ejemplo 'Bunte Bummler - Aesub (Monika Ross Remix)",
                "vocals": "Escucha tu pista en su totalidad. Si tu pista tiene voces, selecciona el idioma de las voces. Si tu pista está libre de voces, selecciona la opción Instrumental. Verifícalo dos veces para estar seguro. Si este dato es incorrecto, algunas tiendas como iTunes y Apple Music rechazarán el lanzamiento.",
                "publishers": {
                    "publisherName": "<strong>Nombre del editor:</strong> Por favor inserta el nombre completo de la compañía editorial si estás utilizando servicios editoriales. Si no estás utilizando servicios editoriales oficiales, por favor inserta/selecciona <strong>Control de Derechos de Autor</strong>. Por favor <strong>no insertes el nombre de tu sello</strong> si no es una compañía editorial registrada. Pueden aplicarse implicaciones legales.",
                    "authorSongWriterName": "<strong>Nombre completo del autor/compositor:</strong> Por favor inserta el <strong>nombre y apellido reales</strong> de la persona."
                },
                "contributors": {
                    "contributorsName": "<strong>Nombre de los colaboradores:</strong> Por favor inserta el <strong>nombre y apellido reales</strong> de la persona.",
                    "contributorsRoles": "<strong>Roles de los colaboradores:</strong> Al menos un colaborador debe ser añadido como <strong>Compositor</strong>. Si tu pista tiene voces, al menos un colaborador debe ser añadido como <strong>Compositor</strong> y un colaborador debe ser añadido como <strong>Letrista</strong>."
                },
                "copyright": "Nombre del titular de los derechos de autor",
                "albumOnly": "Indica si la pista se venderá solo como parte de un lanzamiento conjunto. Ten en cuenta que algunas tiendas podrían anular esta instrucción",
                "explicitContent": "Por favor marca este campo si la pista tiene letras prohibidas",
                "isrc": "El Código Internacional de Grabación Estándar asignado para la pista. Si no tienes el tuyo, generaremos uno para ti",
                "daIsrc": "El Código Internacional de Grabación Estándar asignado para la pista. Si no tienes el tuyo, generaremos uno para ti",
                "language": "¿En qué idioma está escrito el nombre de la pista? Verifica dos veces si no estás seguro. Si este dato es incorrecto, algunas tiendas como iTunes y Apple Music rechazarán el lanzamiento.",
                "labelShare": "<strong>Consejo:</strong> El estándar de la industria para la <strong>participación del sello</strong> es <strong>50%</strong> y <strong>50%</strong> para los <strong>accionistas</strong>. Te recomendamos encarecidamente que insertes el porcentaje de participación exacto al que has acordado con tus artistas, accionistas y socios.",
                "costTypes": {
                    "point1": "Inserta solo <strong>Costos</strong> reales, ocurridos o preacordados por pista. Te recomendamos encarecidamente que no insertes costos falsos.",
                    "point2": "<strong>Tipos de costos</strong> podrían ser cualquier costo fijo o variable, es decir, <strong>Masterización de Audio, Diseño Gráfico, Promoción, Marketing</strong>, o cualquier otro gasto viable gastado para la <strong>Pista</strong> en particular por el <strong>Sello</strong>."
                }
            },
            "button": {
                "submitTrack": "Enviar Pista"
            },
            "message": {
                "successArtistAdded": "¡Se ha añadido un nuevo Artista!",
                "successPublisherAdded": "¡Se ha añadido un nuevo Editor!",
                "successContributorAdded": "¡Se ha añadido un nuevo Colaborador!",
                "successShareholderAdded": "¡Se ha añadido un nuevo Accionista!",
                "successCostTypeAdded": "¡Se ha añadido un nuevo Tipo de Costo!",
                "errorLabelShareInvalid": "Por favor ingresa un valor válido (1-100)",
                "errorFormCannotBeSubmitted": "¡El formulario no puede ser enviado! Por favor llena todos los campos y verifica los errores.",
                "accountingMetadata": {
                    "title": "ADVERTENCIA",
                    "description": {
                        "point1": "METADATOS OPCIONALES - completa esta parte de los metadatos solo si emitirás informes contables a tus artistas o accionistas.",
                        "point2": "Por favor asegúrate de que los datos enviados en esta sección sean completamente precisos, ya que afectarán los informes que enviarás a tus artistas y accionistas.",
                        "point3": "Recomendamos encarecidamente verificar dos veces las entradas ya que después de la presentación, no se recomiendan ediciones y cambios adicionales por el bien de la precisión de los datos.",
                        "point4": "Los informes contables para tus artistas y accionistas tendrán un efecto preciso solo si envías todos los parámetros correctamente y de acuerdo con tus acuerdos con tus artistas y accionistas.",
                        "point5": "Los costos solo pueden agregarse una vez y no pueden editarse más tarde por razones de transparencia y precisión. Asegúrate de insertar todos los costos de la pista con precisión en tu primer intento."
                    }
                }
            }
        }
    },
    "publishersRow": {
        "form": {
            "label": {
                "publishers": "Editores",
                "required": "Requerido",
                "order": "Orden",
                "publisherName": "Nombre del Editor",
                "authorSongWriterName": "Nombre completo del Autor/Compositor"
            },
            "placeholder": {
                "publisherName": "Seleccionar Editor..."
            },
            "button": {
                "addAnother": "Añadir otro",
                "createNew": "¿Crear nuevo?",
                "remove": "Eliminar"
            },
            "message": {
                "publisherRequired": "Por favor selecciona un editor",
                "authorSongWriterRequired": "Por favor inserta el nombre y apellido reales de la persona."
            },
            "modal": {
                "header": "Añadir nuevo Editor",
                "body": {
                    "label": {
                        "name": "Nombre"
                    },
                    "message": {
                        "nameRequired": "El nombre es requerido",
                        "publisherAlreadyExists": "El editor ya existe"
                    }
                },
                "button": {
                    "createNew": "Crear nuevo",
                    "cancel": "Cancelar"
                }
            }
        }
    },
    "contributorsRow": {
        "form": {
            "label": {
                "contributors": "Colaboradores",
                "required": "Requerido",
                "order": "Orden",
                "contributorName": "Nombre completo del Colaborador",
                "contributorRole": "Rol del Colaborador"
            },
            "placeholder": {
                "contributorName": "Seleccionar Colaborador..."
            },
            "button": {
                "addAnother": "Añadir otro",
                "createNew": "¿Crear nuevo?",
                "remove": "Eliminar"
            },
            "modal": {
                "header": "Añadir nuevo Colaborador",
                "body": {
                    "label": {
                        "name": "Nombre"
                    },
                    "help_text": {
                        "name": "Por favor inserta el nombre y apellido completos del compositor. Ejemplo: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "El nombre es requerido",
                        "nameMustNotBeInUppercase": "El nombre no debe estar en mayúsculas",
                        "insertRealName": "Por favor inserta el nombre y apellido reales de la persona.",
                        "errorContributorAlreadyExists": "El colaborador ya existe"
                    }
                },
                "button": {
                    "createNew": "Crear nuevo",
                    "cancel": "Cancelar"
                }
            }
        }
    },
    "shareholdersRow": {
        "form": {
            "label": {
                "order": "Orden",
                "shareholders": "Accionistas",
                "shareholderName": "Nombre del Accionista",
                "shareholderSplit": "División del Accionista (%)",
                "shareholderRoles": "Roles del Accionista"
            },
            "placeholder": {
                "shareholderName": "Seleccionar Accionista...",
                "shareholderSplit": "ej. 50"
            },
            "message": {
                "shareholderRequired": "Por favor selecciona un accionista",
                "shareholderSplitRequired": "Por favor ingresa un valor válido (1-100)",
                "shareholderRolesRequired": "Por favor selecciona al menos un rol",
                "shareSum": "La Participación del Sello y las Divisiones de los Accionistas deben sumar 100%"
            },
            "button": {
                "addAnother": "Añadir otro",
                "createNew": "¿Crear nuevo?",
                "remove": "Eliminar"
            },
            "modal": {
                "header": "Añadir nuevo Accionista",
                "body": {
                    "label": {
                        "name": "Nombre",
                        "email": "Correo Electrónico"
                    },
                    "help_text": {
                        "name": "Por favor inserta el nombre y apellido completos del compositor. Ejemplo: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "El nombre es requerido",
                        "emailRequired": "El correo electrónico es requerido",
                        "emailInvalid": "El correo electrónico no es válido"
                    }
                },
                "button": {
                    "createNew": "Crear nuevo",
                    "cancel": "Cancelar"
                }
            }
        }
    },
    "costTypesRow": {
        "form": {
            "label": {
                "costTypes": "Tipos de Costos",
                "order": "Orden",
                "costType": "Tipo de Costo",
                "cost": "Costo (€)"
            },
            "placeholder": {
                "costType": "Seleccionar Tipo de Costo...",
                "cost": "ej. -7.5"
            },
            "button": {
                "addAnother": "Añadir otro",
                "createNew": "¿Crear nuevo?",
                "remove": "Eliminar"
            },
            "message": {
                "costTypeRequired": "Por favor selecciona un tipo de costo",
                "costNotNegative": "Por favor ingresa un valor negativo, ej. -10.0"
            },
            "modal": {
                "header": "Añadir Nuevo Tipo de Costo",
                "body": {
                    "label": {
                        "name": "Nombre"
                    },
                    "message": {
                        "nameRequired": "El nombre es requerido",
                        "costTypeAlreadyExists": "El tipo de costo ya existe"
                    },
                    "button": {
                        "createNew": "Crear nuevo",
                        "cancel": "Cancelar"
                    }
                }
            }
        }
    }
};

export default tracksES;